import React, { useContext } from "react";
import { CHECK_TYPE_TO_ROUTE } from "../../../constants";
import { PerformedChecks } from "../../../ui";
import { LinkToReportTab } from "../../common";
import { ReportContext } from "../../context";
import styles from "./performedChecks.module.scss";
const PerformedChecksContainer = ({ scans, }) => {
    const { requestedDiff, selectedCheck, StatusCheckLink, diffId } = useContext(ReportContext);
    return (React.createElement(PerformedChecks, { scans: scans, selectedScan: selectedCheck, shouldLinkToAnotherReport: StatusCheckLink !== undefined, requestedDiff: requestedDiff, diffId: diffId, renderCheckLink: function CheckLink(check) {
            var _a, _b;
            const { StatusCheckLink } = useContext(ReportContext);
            if (((_a = check.link) === null || _a === void 0 ? void 0 : _a.type) === "CURRENT_REPORT" &&
                !(check.checkType === "VERSION-DIFF" && !diffId)) {
                return (React.createElement(LinkToReportTab, { to: CHECK_TYPE_TO_ROUTE[check.checkType], id: check.link.label, color: "link", className: styles.details }, check.link.label));
            }
            if (((_b = check.link) === null || _b === void 0 ? void 0 : _b.type) === "NEW_REPORT" && StatusCheckLink) {
                return (React.createElement(StatusCheckLink, { id: `details-${check.description}`, check: check, className: styles.details }));
            }
            return React.createElement(React.Fragment, null);
        } }));
};
export default PerformedChecksContainer;
//# sourceMappingURL=PerformedChecks.js.map